import { render, staticRenderFns } from "./tool.vue?vue&type=template&id=012a278f"
import script from "./tool.vue?vue&type=script&lang=js"
export * from "./tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports